import { Component, Inject, OnInit } from '@angular/core';
import { CsIconModule } from '@components/icon';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { AppConfig } from 'client/app/app.config';
import { InstantCheckupService } from '@services/instant-checkup-service';
import { EventLoggerService } from '@services/event-logger-service';

@Component({
  selector: 'request-photo-bottom-sheet',
  imports: [
    CsIconModule
],
  templateUrl: './request-photo-bottom-sheet.component.html',
})


export class RequestPhotoBottomSheetComponent implements OnInit {
  requiredPhotoType: string;
  skip: boolean = false;

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: { requiredPhotoType: string, currentPhotoType: string, currentImagePath: string, onContinue: () => void },
    private readonly bottomSheetRef: MatBottomSheetRef,
    public readonly appConfig: AppConfig,
    private readonly instantCheckupService: InstantCheckupService,
    private readonly eventLogger: EventLoggerService
  ) {
    this.requiredPhotoType = data.requiredPhotoType;
    this.bottomSheetRef.afterDismissed().subscribe(() => {
      if (!this.skip) {
        this.instantCheckupService.setIsRequestPhotoBottomSheetSkipped(true)
      }
    })
  }

  ngOnInit(): void {
    this.eventLogger.cleverTapEvent('pageOpen', JSON.stringify({ pageName: 'reacquisition_side_photo_nudge' }));
  }

  closeBottomSheet(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'reacquisition_side_photo_skipped' }));
    this.skip = true;
    this.bottomSheetRef.dismiss();
    this.instantCheckupService.setIsRequestPhotoBottomSheetSkipped(this.skip);
  }

  uploadImage(): void {
    this.bottomSheetRef.dismiss();
    this.data.onContinue();
  }
}
